<h1 mat-dialog-title>
    {{title}}
  </h1>
  
  <div mat-dialog-content>
    <!-- 🔧 ADD IMAGE PREVIEW (ONLY SHOWS WHEN imageUrl EXISTS) -->
    <div class="image-preview" *ngIf="data.imageUrl" style="text-align: center; margin-bottom: 16px;">
      <img [src]="data.imageUrl" 
           [alt]="data.imageName || 'Preview'"
           style="max-width: 200px; max-height: 120px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
    </div>
    
    <p>{{message}}</p>
  </div>
  
  <div mat-dialog-actions class="mdc-action-container">
    <button *ngIf="showNoButton" mat-button (click)="onDismiss()">{{noButtonCaption}}</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">{{yesButtonCaption}}</button>
  </div>